var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-linear',{staticClass:"my-0",attrs:{"indeterminate":""}}):_vm._e(),_c('v-row',{attrs:{"wrap":""}},_vm._l((_vm.bizs),function(biz){return _c('v-col',{key:biz._id,attrs:{"cols":"6","sm":"4","md":"3","lg":"2"}},[_c('Cell',{attrs:{"biz":biz}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }